"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.CallEvaluator = void 0;
var node_1 = require("../../node");
var global_1 = require("../global");
var CallEvaluator = (function (_super) {
    __extends(CallEvaluator, _super);
    function CallEvaluator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CallEvaluator.prototype.evaluate = function (expressionNode) {
        var callee = expressionNode.callee;
        if (callee.type === node_1.ExpressionNodeType.Member) {
            return this.evaluateMember(expressionNode);
        }
        else if (callee.type === node_1.ExpressionNodeType.Identifier) {
            return this.evaluateIdentifier(expressionNode);
        }
        throw new Error("invalidSyntax ".concat(callee.type));
    };
    CallEvaluator.prototype.evaluateMember = function (expressionNode) {
        var _this = this;
        var callee = expressionNode.callee, exprArgs = expressionNode.arguments;
        var fn = this.evaluator.evaluateNode(callee, this.context);
        if (fn) {
            var calleeObj = callee.object;
            var fnObject = this.evaluator.evaluateNode(calleeObj, this.context);
            var args = exprArgs.map(function (arg) { return _this.evaluator.evaluateNode(arg, _this.context); });
            return fn.call.apply(fn, __spreadArray([fnObject], args, false));
        }
        return null;
    };
    CallEvaluator.prototype.evaluateIdentifier = function (expressionNode) {
        var _this = this;
        var callee = expressionNode.callee, exprArgs = expressionNode.arguments;
        var contextObject = this.context.object;
        var fnName = callee.name;
        var functionInfo = this.evaluator.functions[fnName];
        if (functionInfo) {
            return this.evaluateCustomIdentifier(expressionNode);
        }
        var globalFn = (0, global_1.getGlobalObjectProperty)(fnName, contextObject);
        if (globalFn !== null) {
            var args = exprArgs.map(function (arg) { return _this.evaluator.evaluateNode(arg, _this.context); });
            return globalFn.apply(void 0, args);
        }
        throw new Error("undefinedFunction ".concat(fnName));
    };
    CallEvaluator.prototype.evaluateCustomIdentifier = function (expressionNode) {
        var _this = this;
        var callee = expressionNode.callee, exprArgs = expressionNode.arguments;
        var fnName = callee.name;
        var numArgs = exprArgs.length;
        var expressionFunction = this.evaluator.functions[fnName];
        var minArity = expressionFunction.minArity, maxArity = expressionFunction.maxArity, evaluateArgsToNodes = expressionFunction.evaluateArgsToNodes, executor = expressionFunction.executor;
        if (numArgs < minArity)
            throw new Error("functionHasTooFewArguments");
        if (maxArity && maxArity > 0 && numArgs > maxArity)
            throw new Error('functionHasTooManyArguments');
        var args = exprArgs.map(function (arg) {
            return _this.evaluator.evaluateNode(arg, __assign(__assign({}, _this.context), { evaluateToNode: evaluateArgsToNodes }));
        });
        return executor(this.context).apply(void 0, args);
    };
    return CallEvaluator;
}(node_1.ExpressionNodeEvaluator));
exports.CallEvaluator = CallEvaluator;
//# sourceMappingURL=call.js.map